import { Users, FileText, CalendarCheck, TrendingUp, Wallet, GraduationCap, LayoutDashboard, Check } from "lucide-react";

const MODULES = [
  { icon: Users, title: "Gestion des élèves", items: ["Inscription des élèves", "Liste des élèves", "Fiches individuelles", "Photos des élèves", "Cartes scolaires avec QR Code", "Statistiques garçons/filles"], wide: true },
  { icon: FileText, title: "Examens et bulletins", items: ["Configuration des examens", "Gestion des matières", "Saisie des notes", "Calcul des moyennes", "Classement", "Résultats", "Bulletins scolaires PDF"], wide: true },
  { icon: CalendarCheck, title: "Suivi scolaire et vie scolaire", items: ["Appel quotidien", "Présences et absences", "Retards", "Calcul des taux de présence", "Comportements positifs et négatifs", "Félicitations", "Sanctions", "Difficultés scolaires", "Conseils pédagogiques"] },
  { icon: TrendingUp, title: "Performances scolaires", items: ["Indice de performance", "Évolution des résultats", "Analyse par matière", "Identification des difficultés", "Statistiques de classe"] },
  { icon: Wallet, title: "Gestion financière", items: ["Inscriptions", "Mensualités", "Cotisations", "Dépenses", "Paiements", "Impayés", "Rapports financiers"] },
  { icon: GraduationCap, title: "Gestion des enseignants", items: ["Liste des enseignants", "Affectation des classes", "Matières", "Suivi pédagogique", "Statistiques"], wide: true },
  { icon: LayoutDashboard, title: "Tableau de bord intelligent", items: ["Effectifs", "Garçons et filles", "Présences", "Absences", "Résultats", "Performances", "Activités récentes"], wide: true },
];

function ModuleCard({ icon: Icon, title, items, wide, index }) {
  return (
    <article className={`ek-rise group bg-white rounded-2xl border border-[#E2E8F0] p-6 hover:border-[#1F7A63]/40 hover:shadow-lg transition-[border-color,box-shadow] duration-200 ${wide ? "md:col-span-3" : "md:col-span-2"}`}
      style={{ animationDelay: `${index * 60}ms` }} data-testid={`module-card-${index}`}>
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-[#E8F2EF] grid place-items-center group-hover:bg-[#1F7A63] transition-colors">
          <Icon className="w-5 h-5 text-[#1F7A63] group-hover:text-white transition-colors" />
        </div>
        <h3 className="text-lg font-bold" style={{ fontFamily: "Outfit" }}>{title}</h3>
      </div>
      <ul className={`mt-5 grid gap-x-4 gap-y-2 ${wide ? "sm:grid-cols-2" : ""}`}>
        {items.map((t) => (
          <li key={t} className="flex items-start gap-2 text-sm text-[#1A2E28]"><Check className="w-4 h-4 text-[#1F7A63] mt-0.5 shrink-0" />{t}</li>
        ))}
      </ul>
    </article>
  );
}

export default function Modules() {
  return (
    <section id="fonctionnalites" className="py-16 md:py-24 bg-white border-y border-[#E2E8F0] scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs font-bold text-[#1F7A63] uppercase tracking-[0.18em]">Fonctionnalités</div>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>Tout ce dont votre école a besoin</h2>
          <p className="mt-3 text-[#5C736A]">Les modules ci-dessous sont déjà disponibles dans EDUKATI et utilisés au quotidien.</p>
        </div>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-6 gap-4 lg:gap-5">
          {MODULES.map((m, i) => <ModuleCard key={m.title} {...m} index={i} />)}
        </div>
      </div>
    </section>
  );
}
